/* ============================================================
   DillySocks — Totebag Deal PDP (sections/ds-totebag-pdp.liquid)

   Verbindet Deal (Mengen-Option) x Groesse mit der Shopify-Variante und
   aktualisiert Preis, Streichpreis, Rabatt-Pillen, "pro Paar", Warenwert,
   Button, Sticky-Leiste und das erste Galeriebild (Variantenbild) live.
   Alle Betraege kommen als Rappen/Cents aus Liquid (data-ds-tb-data) und
   werden mit window.dsMoney im Format des aktiven Markts formatiert —
   nichts ist fest einprogrammiert.

   type="module": noetig fuer den Import, mit dem Horizon nach dem
   Warenkorb-Add den Cart-Drawer/Bubble aktualisiert (wie ds-abo.js).
   ============================================================ */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  var root = document.querySelector('[data-ds-tb]');
  if (!root || root.dataset.dsTbReady === '1') return;
  root.dataset.dsTbReady = '1';

  var dataEl = root.querySelector('[data-ds-tb-data]');
  if (!dataEl) return;
  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var variants = DATA.variants || [];
  if (!variants.length) return;

  var I18N_EL = root.querySelector('[data-ds-tb-i18n]');
  var I18N = I18N_EL ? JSON.parse(I18N_EL.textContent) : {};
  function fmt(str, vars) {
    return (str || '').replace(/\[\[(\w+)\]\]/g, function (_, key) {
      return vars && key in vars ? vars[key] : '';
    });
  }
  function formatMoney(cents) {
    if (typeof window.dsMoney === 'function') return window.dsMoney(cents);
    var m = window.DS_MARKET || {};
    return (cents / 100).toFixed(2) + ' ' + (m.currency || '');
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var dealBtns = $$('[data-ds-tb-deal]');
  var sizeBtns = $$('[data-ds-tb-size]');
  var submitBtn = $('[data-ds-tb-submit]');
  var submitLabel = $('[data-ds-tb-submit-label]');
  var addPrice = $('[data-ds-tb-add-price]');
  var stickyPrice = $('[data-ds-tb-sticky-price]');
  var elPrice = $('[data-ds-tb-price]');
  var elWas = $('[data-ds-tb-was]');
  var elSave = $('[data-ds-tb-save]');
  var elPillSave = $('[data-ds-tb-pill-save]');
  var elWorth = $('[data-ds-tb-worth]');
  var elPerPair = $('[data-ds-tb-perpair]');
  var heroImg = $('[data-ds-tb-hero-img]');

  /* ---------- Zustand ---------- */
  var state = { pairs: null, size: null };

  // Startzustand: ?variant= aus der URL, sonst der Standard-Deal (Setting)
  // mit der ersten verfuegbaren Groesse.
  var urlVariant = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
  var startVariant = variants.filter(function (v) { return v.id === urlVariant; })[0];
  if (!startVariant) {
    startVariant = variants.filter(function (v) { return v.pairs === DATA.defaultPairs && v.available; })[0]
      || variants.filter(function (v) { return v.available; })[0]
      || variants[0];
  }
  state.pairs = startVariant.pairs;
  state.size = startVariant.size;

  function findVariant(pairs, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.pairs === pairs && (size === null || v.size === size)) return v;
    }
    return null;
  }

  function dealFor(pairs) {
    return dealBtns.filter(function (b) { return parseInt(b.dataset.pairs, 10) === pairs; })[0];
  }

  function pctOff(price, full) {
    return full > 0 && full > price ? Math.round(100 - (price / full) * 100) : 0;
  }

  var current = null;

  function render() {
    // Groessen: fuer den gewaehlten Deal ausverkaufte Groessen ausgrauen
    sizeBtns.forEach(function (b) {
      var v = findVariant(state.pairs, b.dataset.dsTbSize);
      b.disabled = !(v && v.available);
    });
    // Deals: fuer die gewaehlte Groesse ausverkaufte Deals ausgrauen
    dealBtns.forEach(function (b) {
      var v = findVariant(parseInt(b.dataset.pairs, 10), state.size);
      b.disabled = !(v && v.available);
    });

    var variant = findVariant(state.pairs, state.size);
    if (!variant || !variant.available) {
      var fallback = variants.filter(function (v) { return v.pairs === state.pairs && v.available; })[0];
      if (fallback) {
        state.size = fallback.size;
        variant = fallback;
      }
    }

    sizeBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.dsTbSize === state.size));
    });
    dealBtns.forEach(function (b) {
      var on = parseInt(b.dataset.pairs, 10) === state.pairs;
      b.setAttribute('aria-checked', String(on));
    });

    // Deal-Karten: Preise fuer DIESE Groesse nachziehen
    dealBtns.forEach(function (b) {
      var pairs = parseInt(b.dataset.pairs, 10);
      var dv = findVariant(pairs, state.size) || findVariant(pairs, null);
      if (!dv) return;
      var full = DATA.singleCents * pairs;
      var p = b.querySelector('[data-ds-tb-deal-price]');
      var w = b.querySelector('[data-ds-tb-deal-was]');
      var s = b.querySelector('[data-ds-tb-deal-sub]');
      if (p) p.textContent = formatMoney(dv.price);
      if (w) {
        w.textContent = full > dv.price ? formatMoney(full) : '';
        w.hidden = !(full > dv.price);
      }
      if (s) {
        var pct = pctOff(dv.price, full);
        var perPair = pairs > 0 ? formatMoney(Math.round(dv.price / pairs)) : '';
        s.innerHTML = (pct > 0 ? '<span class="ds-tb__deal-save">−' + pct + '%</span>' : '') +
          '<span>' + fmt(I18N.per_pair, { price: perPair }) + '</span>';
      }
    });

    if (!variant) return;
    current = variant;

    var fullPrice = DATA.singleCents * variant.pairs;
    var pct = pctOff(variant.price, fullPrice);
    var worth = fullPrice + (DATA.totebagCents || 0);
    var perPair = variant.pairs > 0 ? formatMoney(Math.round(variant.price / variant.pairs)) : '';

    if (elPrice) elPrice.textContent = formatMoney(variant.price);
    if (elWas) {
      elWas.textContent = fullPrice > variant.price ? formatMoney(fullPrice) : '';
      elWas.hidden = !(fullPrice > variant.price);
    }
    [elSave, elPillSave].forEach(function (el) {
      if (!el) return;
      el.textContent = '−' + pct + '%';
      el.hidden = !(pct > 0);
    });
    if (elWorth) elWorth.textContent = formatMoney(worth);
    if (elPerPair) elPerPair.textContent = fmt(I18N.per_pair, { price: perPair });
    if (addPrice) addPrice.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (submitBtn) submitBtn.disabled = !variant.available;

    // "Was steckt drin?": Paarzahl in den Texten nachziehen
    $$('[data-ds-tb-pairs]').forEach(function (el) { el.textContent = String(variant.pairs); });
    // Mini-Pillen in "So funktioniert's" spiegeln die Auswahl
    document.querySelectorAll('[data-ds-tb-pick-deal]').forEach(function (b) {
      b.classList.toggle('is-on', parseInt(b.dataset.dsTbPickDeal, 10) === variant.pairs);
    });
    document.querySelectorAll('[data-ds-tb-pick-size]').forEach(function (b) {
      b.classList.toggle('is-on', b.dataset.dsTbPickSize === variant.size);
    });

    // Erstes Galeriebild = Variantenbild des gewaehlten Deals
    if (heroImg && variant.image && heroImg.dataset.current !== variant.image) {
      heroImg.dataset.current = variant.image;
      heroImg.removeAttribute('srcset');
      heroImg.src = variant.image;
      if (variant.imageAlt) heroImg.alt = variant.imageAlt;
    }

    // URL nachfuehren (?variant=), ohne History-Eintrag
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* no-op */ }

    // Andere Theme-Teile (z.B. Lieferzeile) ueber den Wechsel informieren
    root.dispatchEvent(new CustomEvent('ds:tb:variant', { detail: { variant: variant }, bubbles: true }));
  }

  /* ---------- In den Warenkorb (Cart-AJAX wie ds-abo.js) ---------- */
  var busy = false;
  async function addToCart() {
    if (busy || !current) return;
    busy = true;
    var original = submitLabel ? submitLabel.textContent : '';
    if (submitLabel) submitLabel.textContent = I18N.cart.adding;
    if (submitBtn) submitBtn.disabled = true;

    var deferred = null;
    if (typeof CartLinesUpdateEvent !== 'undefined') {
      deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: current.id, quantity: 1 }],
          promise: deferred.promise
        })
      );
    }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Cart add failed');
      if (deferred) {
        var cart = await (await fetch('/cart.js')).json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, itemCount: cart.item_count, didError: false }
        });
      }
      if (submitLabel) submitLabel.textContent = I18N.cart.added;
      setTimeout(function () {
        if (submitLabel) submitLabel.textContent = original;
        if (submitBtn) submitBtn.disabled = false;
        busy = false;
      }, 2500);
    } catch (e) {
      if (deferred) deferred.resolve({ detail: { didError: true } });
      if (submitLabel) submitLabel.textContent = I18N.cart.error;
      if (submitBtn) submitBtn.disabled = false;
      busy = false;
    }
  }

  /* ---------- Events ---------- */
  dealBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      state.pairs = parseInt(b.dataset.pairs, 10);
      render();
    });
  });
  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      state.size = b.dataset.dsTbSize;
      render();
    });
  });
  if (submitBtn) submitBtn.addEventListener('click', addToCart);

  /* ---------- Galerie-Punkte (Mobile-Swipe) ---------- */
  var gallery = $('[data-ds-tb-gallery]');
  if (gallery) {
    var dots = $$('.ds-tb__gdot');
    gallery.addEventListener('scroll', function () {
      if (!gallery.clientWidth) return;
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach(function (d, i) { d.setAttribute('data-active', String(i === idx)); });
    }, { passive: true });
  }

  /* ---------- "Deal sichern" / "Zum Deal" / "Jetzt verschenken" + Mini-Pillen
     (Menge/Groesse direkt aus "So funktioniert's" waehlen). Die Pillen setzen
     nur den Wert; gescrollt wird ausschliesslich per [data-ds-tb-jump]. ---------- */
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    var pickDeal = ev.target.closest('[data-ds-tb-pick-deal]');
    var pickSize = ev.target.closest('[data-ds-tb-pick-size]');
    if (pickDeal) {
      var p = parseInt(pickDeal.dataset.dsTbPickDeal, 10);
      if (dealFor(p)) { state.pairs = p; render(); }
    }
    if (pickSize) {
      var sz = pickSize.dataset.dsTbPickSize;
      if (sizeBtns.some(function (b) { return b.dataset.dsTbSize === sz; })) { state.size = sz; render(); }
    }
    var jump = ev.target.closest('[data-ds-tb-jump]');
    if (!jump) return;
    ev.preventDefault();
    var buyBox = $('.ds-tb__buy');
    var isSticky = buyBox && window.getComputedStyle(buyBox).position === 'sticky';
    var target = isSticky ? ($('.ds-tb__main') || root) : ($('[data-ds-tb-deals]') || root);
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  render();
})();
